module.exports = __webpack_public_path__ + "static/media/photo-1.23354fda.jpg";